import { Injectable } from '@angular/core';

import { AdditionalInformationValueType, KeyValueInformation } from '@bpos';
import { PlaceBetRequest } from '@bpos/v2/bet-placement';
import { GeolocationConfig } from '@frontend/sports/common/client-config-data-access';

import { GeolocationCheckService } from '../../../../../../lib/geo-location/geo-location-check.service';
import { IBetslipState } from '../../../../../base/store/state';
import { ISlip } from '../../../../bet-generation/models';
import { GeoComplyKeys } from '../../../models';
import { RequestStrategy } from './request-strategies';

@Injectable({
    providedIn: 'root',
})
export default class RegulatoryRequestStrategy implements RequestStrategy {
    constructor(
        private geolocationCheckService: GeolocationCheckService,
        private geolocationConfig: GeolocationConfig,
    ) {}

    isActive(_: IBetslipState): boolean {
        return this.geolocationConfig.saveDeviceDetails;
    }

    updateRequest(request: PlaceBetRequest, _: IBetslipState, __: ISlip[]): void {
        request.additionalInformation.informationItems = this.getGeoComplyDeviceInfo();
    }

    private getGeoComplyDeviceInfo(): KeyValueInformation[] {
        const geoComplyResponse = this.geolocationCheckService.getDeviceInfoResponse();

        return [
            {
                key: GeoComplyKeys.GeoComplyRegion,
                value: geoComplyResponse?.regionName ?? '10',
                valueType: AdditionalInformationValueType.String,
            },
            {
                key: GeoComplyKeys.GeoComplyRegionCode,
                value: geoComplyResponse?.regionCode ?? '1000001',
                valueType: AdditionalInformationValueType.String,
            },
            {
                key: GeoComplyKeys.GeoComplySdkSolution,
                value: geoComplyResponse?.deviceModelSolution ?? '',
                valueType: AdditionalInformationValueType.String,
            },
            {
                key: GeoComplyKeys.GeoComplyOs,
                value: geoComplyResponse?.deviceModelOS ?? '',
                valueType: AdditionalInformationValueType.String,
            },
            {
                key: GeoComplyKeys.GeoComplyUuid,
                value: geoComplyResponse?.deviceUUid ?? '',
                valueType: AdditionalInformationValueType.String,
            },
        ];
    }
}
